import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios, { CancelToken } from "axios";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { StatusCode } from "api/protocols";
import { GetPDFs } from "api/rpc/2024-04/facilityAdmin/facility/pdf";

import { showError } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";
import { valueToString } from "helpers/Helpers";

import Page from "components/page/Page";
import DataTable from "components/dataTable/DataTable";
import DropFilter from "components/dropdown/DropFilter";

interface IPdfFilters {
  type: string;
}

export default function Pdfs() {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const [pdfs, setPdfs] = useState<any[]>(undefined);

  const [filters, setFilters] = useState<IPdfFilters>({
    type: undefined,
  });

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadPDFs(source.token);
    return () => source.cancel();
  }, [filters]);

  async function loadPDFs(token?: CancelToken) {
    if (pdfs !== undefined) {
      setPdfs(undefined);
    }
    const res = await GetPDFs(
      {
        type: filters.type,
      },
      token ? false : true,
      token,
    );

    if (token && token.reason) {
      return;
    }
    if (res.status !== StatusCode.OK) {
      dispatch(showError(t("Error loading PDFs")));
    }

    setPdfs(res.status !== StatusCode.OK ? [] : res.data);
  }

  return (
    <Page
      title={t("PDFs")}
      narrow
    >
      <div className="mb-2">
        <DropFilter
          title={t("Type")}
          filterData={[
            { value: "existing_bookings", title: t("Existing Bookings") },
            { value: "failed_bookings", title: t("Failed Bookings") },
          ]}
          filterLabelPropFromData="title"
          filterIdPropFromData="value"
          filterType="Checkbox"
          applyFilters={filterReturn =>
            setFilters(prevState => ({
              ...prevState,
              type: filterReturn.length > 0 ? filterReturn[0].value : undefined,
            }))
          }
          save
          historyKey="pdf_type_filter"
          leftAligned
          restrain
        />
      </div>
      <DataTable
        columns={[
          { label: t("Title") },
          { label: t("Type") },
          { label: t("Created On") },
          { label: "" },
        ]}
        loading={pdfs === undefined}
      >
        {pdfs?.map(pdf => (
          <tr key={pdf.id}>
            <td>{pdf.title}</td>
            <td>{valueToString(pdf.type)}</td>
            <td>{moment(pdf.created_at).format("MMM DD, YYYY h:mm A")}</td>
            <td>
              <FontAwesomeIcon
                onClick={() => window.open(pdf.source_url)}
                icon={["far", "download"]}
                size="1x"
                className="cursor-pointer"
              />
            </td>
          </tr>
        ))}
      </DataTable>
    </Page>
  );
}
